export default __webpack_public_path__ + "assets/images/8a96e4f5d71294f6a192ef0aec5a99ad.svg";